import { useEffect } from "react";
import PageContainer from "@components/layout/PageContainer";
import { useParams } from "react-router-dom";
import styles from "./style.module.scss";
import SettlementForm from "@components/forms/SettlementForm";
import AddProductToDocumentOffCanvas from "@components/layout/Offcanvas/AddProductToDocumentOffCanvas";
import AddClientOffCanvas from "@components/layout/Offcanvas/AddClientOffCanvas";
import { ClientDataType } from "@/api/ClientApi";
import { AddClientToDocumentPubSub, LoadInvoiceTemplatePubSub } from "@utils/pubsubs/PubSub";
import { InvoiceTemplateDataType } from "@/api/InvoiceTemplateApi";

type SettlementAddProps = {
  copyData?: boolean
}

const SettlementAdd = (props: SettlementAddProps) => {
  const { copyData = false } = props
  const params = useParams()
  const { id: copySettlementId } = params;

  useEffect(() => {
  }, []);

  const onClientStored = (clientData?: ClientDataType) => {
    if (clientData) {
      AddClientToDocumentPubSub.publish({ client: clientData })
    }
  }

  const onTemplateSelect = (settlementTemplate: InvoiceTemplateDataType) => {
    LoadInvoiceTemplatePubSub.publish({ invoiceTemplate: settlementTemplate })
  }

  return (
    <PageContainer
      containerClassName={styles.mainContainer}
      title="Agregar Liquidacion"
      backUrl="/user/settlements"
      primaryActions={[
        {
          actionTitle: "Guardar",
          formId: "settlementAdd",
          type: "submit",
          color: "success"
        },
        {
          customElement: (
            <AddProductToDocumentOffCanvas
              onTemplateSelect={onTemplateSelect}
              btnColor="success">
              Agregar Producto
            </AddProductToDocumentOffCanvas>
          )
        }
      ]}
    >
      <SettlementForm
        id={copySettlementId}
        copyData={copyData}
        saveRedirectUrl="/user/settlements"
        formId="settlementAdd" >
      </SettlementForm>

      <AddClientOffCanvas
        onStored={onClientStored} />

    </PageContainer>
  );
}

export default SettlementAdd;
